module.exports = __webpack_public_path__ + "img/65_5.9ae92d05.png";